export default {
	app: {
		newVersionAvailable: "New version available.",
		update: "Update",
	},
	header: {
		brand: "Zato Timbrature",
		development: "DEVELOPMENT",
		offline: "You are offline",
	},
	home: {
		connectedAs: "Connected as",
		logout: "Logout",
	},
	login: {
		title: "Login",
		username: "Username",
		password: "Password",
		submit: "Sign in",
		copyright: "Copyright © 2024 Servonet Srl - Beta version",
	},
	dataSync: {
		title: "Data synchronization",
		loading: "Loading...",
	},
	stampings: {
		order: "Order",
		users: "Users",
		travelType: "Travel type",
		travelTypeNone: "None",
		travelTypePlane: "Plane",
		travelTypeCarOrTruck: "Car/Van",
		workType: "Work type",
		notes: "Notes",
		loading: "Loading...",
		start: "Start",
		stopSelected: "Stop selected stampings",
		tableUser: "User",
		tableTimer: "Timer",
		tableStart: "Start",
		tableEnd: "End",
		tableOrder: "Order",
		tableWorkType: "Work type",
		tableNotes: "Notes",
		tableActions: "Actions",
		noItems: "No items available",
		unsyncedItems: "Unsynchronized stampings",
		alertOrderRequired: "Order is required",
		alertErrorOpen: "An error occurred while opening the stamping",
		alertDuplicateUser: "Cannot create new stampings for users who already have an open stamping",
		alertErrorClose: "An error occurred while closing the stamping",
		alertErrorUpdate: "An error occurred while updating the stamping",
	},
	errors: {
		offline: "An error occurred during the request; the device may be offline.",
		generic: "An error occurred during the request.",
	},
}
